export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M4.646 7.646a.5.5 0 01.708 0L8 10.293l2.646-2.647a.5.5 0 01.708.708l-3 3a.5.5 0 01-.708 0l-3-3a.5.5 0 010-.708z\"/><path fill-rule=\"evenodd\" d=\"M8 4.5a.5.5 0 01.5.5v5a.5.5 0 01-1 0V5a.5.5 0 01.5-.5z\"/>",
  "attrs": {
    "width": "1em",
    "height": "1em",
    "viewBox": "0 0 16 16",
    "class": "bi bi-arrow-down-short",
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};